export interface IAuthData {
  accountNumber: string;
  code: number;
  description: string;
  deviceTied: boolean;
  email: string;
  freshRegistration: boolean;
  fullname: string;
  companyName: string;
  roles: {name: string} [];
  menus: {title: string}[];
  lastLoginTime: string;
  loginId: string;
  maxDeviceCountAllowed: 2;
  myDevice: boolean;
  usernamePasswordChangeRequired: boolean;
  passwordChangeRequired: boolean;
  secretQAUpdateRequired: boolean;
  phoneNumber: string;
  pinChangeRequired: boolean;
  ibPinChangeRequired: boolean;
  registeredDeviceCount: number;
  sessionID: string;
  sessionTimeoutInSeconds: number;
  signedIndemnity: boolean;
  stopChequeCharge: string;
  firstLogin: boolean;
}

export interface IApiResponse {
  code: number;
  description: string;
  failureCount?: number;
  transactionId?: number;
}

export interface ICustomer {
  id: number;
  dateRegistered: string;
  dateCreated: string;
  fullname: string;
  primaryAccountNumber: string;
  phoneNumber: string;
  onboardMode: string;
  bankID: string;
  userName: string;
  lastLoginTime: string;
  roles:{name: string}[];
  regDevice: {
    uniqueId: string;
    model: string;
    deviceName: string;
  };
  profileStatus: string;
  sessionData: {
    sessionId: string;
    logonTime: string;
    lastActiveTime: string;
    deviceId: string;
    timeoutSeconds: number;
  };
  pinSalt: string;
  pin: string;
  pinChangeRequired: boolean;
  pinBlocked: boolean;
  transactionPinSalt: string;
  transactionPin: string;
  transactionPinChangeRequired: boolean;
  transactionPinBlocked: boolean;
  secretQuestion: string;
  secretAnswer: string;
  secretAnswerSalt: string;
}

export interface ILoginBody {
  loginID: string;
  password: string;
  deviceID: string;
  longitude: number;
  latitude: number;
  deviceModel: string;
  isRootConsented: boolean;
}

export interface IOtpResendBody {
  accountNumber: string;
  deviceID: string;
}

export interface ITransferBeneficiary {
  id: number;
  transferType: 'LOCAL' | 'NON_INSTANT_INTERBANK' | 'INSTANT_INTERBANK';
  name: string;
  bankCode: string;
  bankName: string;
  alias: string;
  instantId?: string;
  accountNumber: string;
  customer: ICustomer;
}

export interface ITransferBenLocationData {
  destinationAccountNo: string;
  destinationBankCode: string;
  transferType: ITransferBeneficiary['transferType'];
}

export interface IOtpResponse extends IApiResponse {
  sessionId?: string;
  otpSession?: string;
}

export type UserRoles = 'Single' | 'Initiator' | 'Authorizer' | 'Viewer' | 'Initiator & Authorizer'

export enum Signatory {
  SINGLE = 'Single',
  INITIATOR = 'Initiator',
  AUTHORIZER = 'Authorizer',
  VIEWER = 'Viewer',
  INITIATOR_AUTHORIZER = 'Initiator & Authorizer'
}
